import {viewModel} from '@/class/view-model'
import {Media, PK} from '@/class/data-type'

export class annotation extends viewModel {
    
    objectType = 'annotation';
    
    /**
     * variables de données
     */
    _pk = new PK('id');
    data = [
      {name: 'text', type: String, default: ''},
      {name: 'image', type: Media, default: new Media({type:'picture'})}
    ]
    
    _edit = false;
    
    constructor () {
      super()
      this.init()
    }
    
    edit () {
      this._edit = true
    }
    unEdit () {
      this._edit = false
    }
    isEdit () {
      return this._edit
    }
    
    
}
